import React, { useEffect, useState } from "react";
import productAPI from "../../api/productApi";
import Product from "../products/Card";
import { X } from "lucide-react";

function SearchCanvas({ isOpen }) {
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [page, setPage] = useState(1);
     const [isSearchOpen, setIsSearchOpen] = useState(false);

  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    fetchProducts(1, searchText);
  }, [searchText]);

  const fetchProducts = async (pageNum = 1, searchText) => {
    setLoading(true);

    try {
      if (searchText) {
        const res = await productAPI.listing({
          page: pageNum,
          limit: 6,
          keyword: searchText,
        });

        if (res.code === 200) {
          const { products, base_url } = res.data;

          const items = products;

          setProducts((prev) => (pageNum === 1 ? items : [...prev, ...items]));
        }
      }
    } catch (err) {
      console.error("Error loading products:", err);
    } finally {
      setLoading(false);
    }
  };

  

  return (
    <div className="modal-dialog modal-fullscreen">
      <div className="modal-content">
        <div className="header">
          <button
            className="icon-close icon-close-popup"
            data-bs-dismiss="modal"
          />
        </div>
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="looking-for-wrap">
                <div className="heading">What are you looking for?</div>
                <form className="form-search">
                  <fieldset className="text">
                    <input
                      type="text"
                      placeholder="Search By Product Name"
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      tabIndex={0}
                      required
                    />
                  </fieldset>
                  {/* <button type="button">
                    <i className="icon icon-search" />
                  </button> */}
                </form>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="featured-product">
                <div className="row">
                  {products.map((product, index) => (
                    <div className="col-md-3" key={product._id}>
                      <Product item={product} />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>



   
  );
}

export default SearchCanvas;
